import { Box, Button, Typography } from "@mui/material";
import { snakeToTitleCase } from "@/utils";
import { StyledContainedButton } from "./styles";
import { delete_img } from "@/constants";
import { IconImage } from "@/components";
import { IoMdClose } from "react-icons/io";
import { unlock_right } from "@/constants";

export const tenantColumns = (
  handleTriggerModal: (item: any, type: string) => void
): IColumn<ITenant>[] => [
  {
    name: "Tenant Name",
    key: "companyName",
    align: "left",
    width: "148px",
    component: (item) => (
      <Box display={"flex"} alignItems={"center"} gap={1}>
        <img
          src={item.companyLogo}
          alt="logo"
          width={20}
          height={20}
        />
        <Typography variant="body2" color={"#030712"}>
          {item.companyName}
        </Typography>
      </Box>
    ),
  },
  {
    name: "Company Email",
    key: "companyEmail",
    align: "left",
    width: "148px",
  },
  {
    name: "Tenant Type",
    key: "tenantType",
    align: "left",
    width: "148px",
    component: (item) => (
      <StyledContainedButton
        variant="outlined"
        sx={{
          color: item.tenantType === "SERVICE_PROVIDER" ? "rgba(234, 67, 52, 1)" : "rgba(52, 168, 83, 1)",
        }}
        title={snakeToTitleCase(item.tenantType)}
      />
    ),
  },
  {
    name: "Client IDs",
    key: "_id",
    align: "left",
    width: "220px",
    component: (item: any) => {
      const isTradediveClient = item?.tenantType === "TRADEDIVE_CLIENT";
      const users: Array<{ _id: string }> = item?.users || [];
      if (!isTradediveClient) return <></>;
      if (!users.length) {
        return (
          <Typography variant="body2" color={"#6B7280"}>
            N/A
          </Typography>
        );
      }
      return (
        <Box display="flex" flexDirection="column" gap={0.5}>
          {users.map((u) => (
            <Typography key={u._id} variant="body2" color={"#030712"}>
              {u._id}
            </Typography>
          ))}
        </Box>
      );
    },
  },
  {
    name: "Actions",
    key: "actions",
    align: "center",
    width: "346px",
    component: (item: ITenant) => {
    const isRestricted = item.isRestricted;
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap={1}
      >
        <StyledContainedButton
          startIcon={
            isRestricted ? (
              <IconImage src={unlock_right} size="auto" />
            ) : (
              <IoMdClose />
            )
          }
          // disabled={!isCurrentUserAdmin}
          onClick={(e) => {
            e.stopPropagation();
            handleTriggerModal(item, isRestricted ? "unblock" : "restrict");
          }}
          sx={{
            color: isRestricted
              ? "rgba(52, 168, 83, 1)"
              : "rgba(234, 67, 52, 1)",
          }}
          variant="outlined"
          title={isRestricted ? "Unblock" : "Restrict"}
        />

        <Button
          // disabled={!isCurrentUserAdmin}
          variant="outlined"
          onClick={(e) => {
            e.stopPropagation();
            handleTriggerModal(item, "delete");
          }}
          style={{
            color: "#EA4334",
            borderColor: "#E6E7E7",
            fontWeight: 500,
          }}
        >
          <IconImage src={delete_img} size="auto" />
        </Button>
      </Box>
    );
  },
},
];
